export class StudentNoteModel {
  constructor() {
    this.students = [];
    this.attachmentIds = [];
  }
  noteMessage: string;
  classId: number;
  sectionId: number;
  students: string[];
  attachmentIds: number[];
  sectionSubjectId: number;
  noteTypeId: number;
  dateFilter: string;
  startDate: string;
  endDate: string;
  noteDate: string;
  className: string;
  classNameEn: string;
  sectionSubjectName: string;
  sectionSubjectNameEn: string;
  sectionName: string;
  sectionNameEn: string;
}

export class StudentsNotes {
  studentId: string;
  studentName: string;
  studentNameEn: string;
  imageUrl?: string;
  noteCount?: number;
  studentNumber?: string;
}

export class NotesStudents {
  noteId: number;
  noteTypeId: number;
  noteDate: string;
  noteMessage: string;
  staffMember: StaffMember;
  studentCount: number;
  students: StudentsNotes[];
  sectionSubjectId: number;
  subjectName: string;
  subjectNameEn: string;
  classId: number;
  className: string;
  classNameEn: string;
  sectionId: number;
  sectionName: string;
  sectionNameEn: string;
}
export class StaffMember {
  staffMemberId: string;
  staffMemberName: string;
  staffMemberNameEn: string;
  staffMemberImage: string;
}
export class NoteModel {
  noteId: number;
  noteMessage: string;
  classId: number;
  sectionId: number;
  subjectId: number;
  noteTypeId: number;
  subjectName: string;
  subjectNameEn: string;
  noteDate: string;
}

export class StudentModel {
  studentId: string;
  name: string;
  nameEn: string;
  imageUrl?: string;
}
export class NoteStatisticsFilter {
  classId: number;
  sectionId: number;
  sectionSubjectId: number;
  from?: string;
  to?: string;
  month?: string;
  year?: string;
}
export class PublicNotesDiscussions {
  noteId: number;
  noteMessage: string;
  noteDate: string;
  studentId: string;
  studentName: string;
  studentNameEn: string;
  postId: number;
}
export enum ActionTypes {
  public = 1,
  private = 2
}
